//---------------------------------------------------
//-- Mixins (Rutinas y Código de Acceso Global)
//---------------------------------------------------

import { SnotifyPosition, SnotifyStyle }     from 'vue-snotify';

//-- Comunicación HTTP, FTP, ...
const axios = require("axios");

export default {


  //--------------------- Variables GLOBALES  ---------------------------
  data () {
      return {

        HtmlEntitiesMap : {
          "'": "&apos;",
          "<": "&lt;",
          ">": "&gt;",
          " ": "&nbsp;",
          "¡": "&iexcl;",
          "¢": "&cent;",
          "£": "&pound;",
          "¤": "&curren;",
          "¥": "&yen;",
          "¦": "&brvbar;",
          "§": "&sect;",
          "¨": "&uml;",
          "©": "&copy;",
          "ª": "&ordf;",
          "«": "&laquo;",
          "¬": "&not;",
          "®": "&reg;",
          "¯": "&macr;",
          "°": "&deg;",
          "±": "&plusmn;",
          "²": "&sup2;",
          "³": "&sup3;",
          "´": "&acute;",
          "µ": "&micro;",
          "¶": "&para;",
          "·": "&middot;",
          "¸": "&cedil;",
          "¹": "&sup1;",
          "º": "&ordm;",
          "»": "&raquo;",
          "¼": "&frac14;",
          "½": "&frac12;",
          "¾": "&frac34;",
          "¿": "&iquest;",
          "À": "&Agrave;",
          "Á": "&Aacute;",
          "Â": "&Acirc;",
          "Ã": "&Atilde;",
          "Ä": "&Auml;",
          "Å": "&Aring;",
          "Æ": "&AElig;",
          "Ç": "&Ccedil;",
          "È": "&Egrave;",
          "É": "&Eacute;",
          "Ê": "&Ecirc;",
          "Ë": "&Euml;",
          "Ì": "&Igrave;",
          "Í": "&Iacute;",
          "Î": "&Icirc;",
          "Ï": "&Iuml;",
          "Ð": "&ETH;",
          "Ñ": "&Ntilde;",
          "Ò": "&Ograve;",
          "Ó": "&Oacute;",
          "Ô": "&Ocirc;",
          "Õ": "&Otilde;",
          "Ö": "&Ouml;",
          "×": "&times;",
          "Ø": "&Oslash;",
          "Ù": "&Ugrave;",
          "Ú": "&Uacute;",
          "Û": "&Ucirc;",
          "Ü": "&Uuml;",
          "Ý": "&Yacute;",
          "Þ": "&THORN;",
          "ß": "&szlig;",
          "à": "&agrave;",
          "á": "&aacute;",
          "â": "&acirc;",
          "ã": "&atilde;",
          "ä": "&auml;",
          "å": "&aring;",
          "æ": "&aelig;",
          "ç": "&ccedil;",
          "è": "&egrave;",
          "é": "&eacute;",
          "ê": "&ecirc;",
          "ë": "&euml;",
          "ì": "&igrave;",
          "í": "&iacute;",
          "î": "&icirc;",
          "ï": "&iuml;",
          "ð": "&eth;",
          "ñ": "&ntilde;",
          "ò": "&ograve;",
          "ó": "&oacute;",
          "ô": "&ocirc;",
          "õ": "&otilde;",
          "ö": "&ouml;",
          "÷": "&divide;",
          "ø": "&oslash;",
          "ù": "&ugrave;",
          "ú": "&uacute;",
          "û": "&ucirc;",
          "ü": "&uuml;",
          "ý": "&yacute;",
          "þ": "&thorn;",
          "ÿ": "&yuml;",
          "Œ": "&OElig;",
          "œ": "&oelig;",
          "Š": "&Scaron;",
          "š": "&scaron;",
          "Ÿ": "&Yuml;",
          "ƒ": "&fnof;",
          "ˆ": "&circ;",
          "˜": "&tilde;",
          "Α": "&Alpha;",
          "Β": "&Beta;",
          "Γ": "&Gamma;",
          "Δ": "&Delta;",
          "Ε": "&Epsilon;",
          "Ζ": "&Zeta;",
          "Η": "&Eta;",
          "Θ": "&Theta;",
          "Ι": "&Iota;",
          "Κ": "&Kappa;",
          "Λ": "&Lambda;",
          "Μ": "&Mu;",
          "Ν": "&Nu;",
          "Ξ": "&Xi;",
          "Ο": "&Omicron;",
          "Π": "&Pi;",
          "Ρ": "&Rho;",
          "Σ": "&Sigma;",
          "Τ": "&Tau;",
          "Υ": "&Upsilon;",
          "Φ": "&Phi;",
          "Χ": "&Chi;",
          "Ψ": "&Psi;",
          "Ω": "&Omega;",
          "α": "&alpha;",
          "β": "&beta;",
          "γ": "&gamma;",
          "δ": "&delta;",
          "ε": "&epsilon;",
          "ζ": "&zeta;",
          "η": "&eta;",
          "θ": "&theta;",
          "ι": "&iota;",
          "κ": "&kappa;",
          "λ": "&lambda;",
          "μ": "&mu;",
          "ν": "&nu;",
          "ξ": "&xi;",
          "ο": "&omicron;",
          "π": "&pi;",
          "ρ": "&rho;",
          "ς": "&sigmaf;",
          "σ": "&sigma;",
          "τ": "&tau;",
          "υ": "&upsilon;",
          "φ": "&phi;",
          "χ": "&chi;",
          "ψ": "&psi;",
          "ω": "&omega;",
          "ϑ": "&thetasym;",
          "ϒ": "&Upsih;",
          "ϖ": "&piv;",
          "–": "&ndash;",
          "—": "&mdash;",
          "‘": "&lsquo;",
          "’": "&rsquo;",
          "‚": "&sbquo;",
          "“": "&ldquo;",
          "”": "&rdquo;",
          "„": "&bdquo;",
          "†": "&dagger;",
          "‡": "&Dagger;",
          "•": "&bull;",
          "…": "&hellip;",
          "‰": "&permil;",
          "′": "&prime;",
          "″": "&Prime;",
          "‹": "&lsaquo;",
          "›": "&rsaquo;",
          "‾": "&oline;",
          "⁄": "&frasl;",
          "€": "&euro;",
          "ℑ": "&image;",
          "℘": "&weierp;",
          "ℜ": "&real;",
          "™": "&trade;",
          "ℵ": "&alefsym;",
          "←": "&larr;",
          "↑": "&uarr;",
          "→": "&rarr;",
          "↓": "&darr;",
          "↔": "&harr;",
          "↵": "&crarr;",
          "⇐": "&lArr;",
          "⇑": "&UArr;",
          "⇒": "&rArr;",
          "⇓": "&dArr;",
          "⇔": "&hArr;",
          "∀": "&forall;",
          "∂": "&part;",
          "∃": "&exist;",
          "∅": "&empty;",
          "∇": "&nabla;",
          "∈": "&isin;",
          "∉": "&notin;",
          "∋": "&ni;",
          "∏": "&prod;",
          "∑": "&sum;",
          "−": "&minus;",
          "∗": "&lowast;",
          "√": "&radic;",
          "∝": "&prop;",
          "∞": "&infin;",
          "∠": "&ang;",
          "∧": "&and;",
          "∨": "&or;",
          "∩": "&cap;",
          "∪": "&cup;",
          "∫": "&int;",
          "∴": "&there4;",
          "∼": "&sim;",
          "≅": "&cong;",
          "≈": "&asymp;",
          "≠": "&ne;",
          "≡": "&equiv;",
          "≤": "&le;",
          "≥": "&ge;",
          "⊂": "&sub;",
          "⊃": "&sup;",
          "⊄": "&nsub;",
          "⊆": "&sube;",
          "⊇": "&supe;",
          "⊕": "&oplus;",
          "⊗": "&otimes;",
          "⊥": "&perp;",
          "⋅": "&sdot;",
          "⌈": "&lceil;",
          "⌉": "&rceil;",
          "⌊": "&lfloor;",
          "⌋": "&rfloor;",
          "⟨": "&lang;",
          "⟩": "&rang;",
          "◊": "&loz;",
          "♠": "&spades;",
          "♣": "&clubs;",
          "♥": "&hearts;",
          "♦": "&diams;"
      }

     }          
        
    },



  //----------------- Variables Calculadas GLOBALES  --------------------
  computed: {

    //-- Retornar el Valor del ANCHO de Pantala
    f99AppScreenWidth() {
      //console.log('-- f99AppScreenWidth --'+this.$appScreenWidth);
      return this.$appScreenWidth;
    },

    //-- Retornar el Valor del ALTO de Pantalla
    f99AppScreenHeight() {
      //console.log('-- f99AppScreenHeight --'+this.$appScreenHeight);
      return this.$appScreenHeight;
    }

  },



  //--------------------- Observadores GLOBALES -------------------------
  watch: {
  },



  //----------------------- Métodos GLOBALES  ---------------------------
  methods: {

      //:::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
      //:::  fNNxxxxxxx  - Modelo de Nomenclatura a aplicar
      //:::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
      //:::
      //:::      (f) = Función        (SÍ retorna un resultado)
      //:::      (p) = Procedimiento  (NO retorna resultados)
      //:::
      //:::      (NN) = Tipo de Función/Procedimiento
      //:::       60  - Procesos de caracter GENERAL
      //:::       70  - Tratamiento de FECHAS
      //:::       90  - Mostrar Contenido en Pantalla
      //:::       97  - Lectura/Escritura Datos sobre URL
      //:::       99  - Mensajes Interactivos (Alertas, Preguntas, ...)
      //:::
      //:::      (xxxxxx) = Nombre de Función/Procedimiento
      //:::
      //:::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

      
      //----------------------------------------------------------
      //--- Rutinas Generales al Inicio de cada Vista
      //----------------------------------------------------------
      p10Inicio() {

        //-- Si no hay sesión : Página Inicial
        if ( this.$store.state.strIDSesion == "") {
            this.p99AnuncioIH1('4','7','Atención', 'Sesión CADUCADA<br/>Debe identificarse de nuevo',10);
            this.$router.push('/');
        }

        //-- TODO : Si la sesión no es de 20 caracteres, o los 2 últimos no son "cm" : Sesión Corrupta
  

      },

      //----------------------------------------------------------
      //--- Conversión AAAAMMDD en DD-MM-AAAA
      //----------------------------------------------------------
      f70AMD2fDMA(fecha){
        var ano       = fecha.substr(0,4);
        var mes       = fecha.substr(4,2);
        var dia       = fecha.substr(6,2);
  
        return dia + global.lnkDateSeparator + mes + global.lnkDateSeparator + ano;
      },

      //----------------------------------------------------------
      //--- Conversión AAAAMMDD en DD-MM-AA
      //----------------------------------------------------------
      f70AMD2sDMA(fecha){
        var ano       = fecha.substr(2,2);
        var mes       = fecha.substr(4,2);
        var dia       = fecha.substr(6,2);
  
        return dia + global.lnkDateSeparator + mes + global.lnkDateSeparator + ano;
      },

      //----------------------------------------------------------
      //--- Conversión HHMMSS en HH:MM:SS
      //----------------------------------------------------------
      f70HMS2fHMS(tiempo){
        var hora      = tiempo.substr(0,2);
        var minuto    = tiempo.substr(2,2);
        var segundo   = tiempo.substr(4,2);
  
        //console.log('Tiempo : ['+tiempo+']');
        //console.log(' Hora  : ['+hora+'] Minuto : ['+minuto+'] Segundo : ['+segundo+']');
        return hora + global.lnkTimeSeparator + minuto + global.lnkTimeSeparator + segundo;
      },


      //------------------------------------------------------------------
      //--- Creación de HASH SHA-256, a partir del (mensaje) indicado
      //--- Formatos de Salida : (1)-Hexadecimal  (2)-Base64
      //------------------------------------------------------------------
      f70SHA256(mensaje,formato) {
        var crypto = require('crypto');

        if (formato == '1') {
          const hash = crypto.createHash('sha256').update(mensaje).digest('hex');
          return hash;
        } else {
          const hash = crypto.createHash('sha256').update(mensaje).digest('base64');
          return hash;
        }
                
      },

      //----------------------------------------------------------
      //--- Ofuscar Texto (Encode)
      //----------------------------------------------------------
      f75OfuscarTexto(texto) {
        var base64 = require('base-64');

        //-- Fase I
        var resultado = base64.encode(texto);

        //-- Fase II
        resultado = base64.encode(resultado);

        //-- Fase III
        resultado = base64.encode(resultado);

        //-- Devolver texto Ofuscado
        return resultado;
      },

      //----------------------------------------------------------
      //--- Desofuscar Texto (Decode)
      //----------------------------------------------------------
      f75DesofuscarTexto(texto) {
        var base64 = require('base-64');

        //-- Fase I
        var resultado = base64.decode(texto);

        //-- Fase II
        resultado = base64.decode(resultado);

        //-- Fase III
        resultado = base64.decode(resultado);

        //-- Devolver texto Ofuscado
        return resultado;
      },



      //----------------------------------------------------------
      //--- Decodificar HTML Entities
      //----------------------------------------------------------
      f79DecodeHTML(texto) {

        //-- Casos especiales
        if ((typeof texto == 'undefined') || (texto == '')) {
          return '';
        }

        //-- Como norma general
        var entityMap = this.HtmlEntitiesMap;
        for (var key in entityMap) {
            var entity = entityMap[key];
            var regex = new RegExp(entity, 'g');
            texto = texto.replace(regex, key);
        }

        texto = texto.replace(/&quot;/g, '"');
        texto = texto.replace(/&amp;/g, '&');

        return texto;
      },
      
      //----------------------------------------------------------
      //--- Codificar HTML Entities
      //----------------------------------------------------------
      f79EncodeHTML(texto) {
        //-- Casos especiales
        if ((typeof texto == 'undefined') || (texto == '')) {
          return '';
        }
  
        //-- Como norma general
        var entityMap = this.HtmlEntitiesMap;
        texto = texto.replace(/&/g, '&amp;');
        texto = texto.replace(/"/g, '&quot;');

        for (var key in entityMap) {
            var entity = entityMap[key];
            var regex = new RegExp(key, 'g');
            texto = texto.replace(regex, entity);
        }

        return texto;
      },    


      //---------------------------------------------------------------
      //--- Complementar [numero_espacios] por la izquierda y derecha
      //---------------------------------------------------------------
      f91Pad(texto, numero_espacios) {
      
        //-- Verificar que se trata de un campo en formato "texto" (si no fuese así -> corregir)
        if (typeof texto == 'undefined') { texto = ""; }
        if (typeof texto == 'number')    { texto = texto.toString(); }

        //-- Dado que [numero_espacios] es opcional : revisar, y si viene sin cubrir -> asumir 0
        numero_espacios = numero_espacios || 0;

        //-- La concatenación pudiera contener algún fragmento "undefined"
        var n = texto.search("undefined");
        if (n !== -1) { texto = '...'; }

        //-- Convertir valor HTTP (%xy) en (caracter standard) (ejemplo : %3d -> '=')
        texto = unescape(texto);

        //-- Complementar con espacios
        return " ".repeat(numero_espacios) + texto + " ".repeat(numero_espacios);
      },

      //----------------------------------------------------------
      //--- Cantidad con Formato
      //----------------------------------------------------------
      f91Cantidad(value) {
        //-- Si no se recibe un número devolvemos [valor vacío]
        if (isNaN(value)) { return ""; }

        //-- Determinar si precisa decimales (o no)
        let val  = Math.round(value);
        if (val != value) {  val = (value/1).toFixed(2).replace('.', ','); }

        //-- Maquetar
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      },

      //----------------------------------------------------------
      //--- Importe con Formato
      //----------------------------------------------------------
      f91Importe(value) {
        //-- Si no se recibe un número devolvemos [valor vacío]
        if (isNaN(value))       { return "";  }
        if (!isFinite(value))   { return "-"; }

        //-- Resto de Casos
        let val = (value/1).toFixed(2).replace('.', ',');
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      },

      //----------------------------------------------------------
      //--- Porcentaje con Formato
      //----------------------------------------------------------
      f91Porcentaje(value) {
        //-- Si no se recibe un número devolvemos [valor vacío]
        if (isNaN(value))       { return "";  }
        if (!isFinite(value))   { return "-"; }

        //-- Resto de Casos
        let val = (value/1).toFixed(2).replace('.', ',');
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      },
      
      //--------------------------------------------------------------
      //--- Símbolo de la Moneda en la que está expresado el Importe
      //--------------------------------------------------------------
      f91Moneda(value) {
        //-- Si no se recibe un número devolvemos [valor vacío]
        if (isNaN(value)) { return ""; }

        //-- Resto de Casos
        return " €";
      },

      //--------------------------------------------------------------
      //--- Convertir campo Fecha en Formato (aaaammdd) a Date
      //--------------------------------------------------------------
      f92AMD2Date(fecha) {
        //console.log('f92AMD2Date = '+fecha);
        var date = new Date(parseInt(fecha.substr(0,4)), parseInt(fecha.substr(4,2))-1 , parseInt(fecha.substr(6,2)) );
        //console.log('f92AMD2Date : '+date);
        return   date;
      },

      
      //--------------------------------------------------------------
      //--- Convertir campo (Date) a Fecha en Formato (aaaammdd)
      //--------------------------------------------------------------
      f92Date2AMD(date) {
        const d = date.getDate();
        const m = date.getMonth() + 1;
        const y = date.getFullYear();

        return   y + (m < 10 ? '0' : '') + m + (d < 10 ? '0' : '') + d;
      },


      //--------------------------------------------------------------
      //--- Convertir campo (Date) a Fecha en Formato (dd-mm-aaaa)
      //--------------------------------------------------------------
      f92Date2DMA(date) {
        const d = date.getDate();
        const m = date.getMonth() + 1;
        const y = date.getFullYear();
        return (d < 10 ? '0' : '') + d + '-' + (m < 10 ? '0' : '') + m + '-' + y;
      },

      //--------------------------------------------------------------
      //--- Convertir campo (Date) a Hora en Formato (HH:MM:SS)
      //--------------------------------------------------------------
      f92Date2HMS(date) {
        const h = date.getHours();
        const m = date.getMinutes();
        const s = date.getSeconds();
        return (h < 10 ? '0' : '') + h + ':' + (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
      },



      //----------------------------------------------------------
      //--- Componer la URL con la cual reclamar los Datos
      //----------------------------------------------------------
      f97GetURL(tabla, metodo) {
        //-- Retornar la URL a utilizar
        var URL = global.lnkServerAppURL + "s="+this.$store.state.strIDSesion+"&u="+this.$store.state.strUsuario+"&d="+this.$store.state.strDistribuidor+"&c="+this.$store.state.strCliente+"&t=" + tabla + "&m=" + metodo + "&n=" + encodeURIComponent(this.$store.state.strNifClienteOfuscado);

        //-- Informar Tabla y Método solicitado (y la URL completa)
        console.info("Reclamando Datos ('"+tabla+"','"+metodo+"') ==> "+URL);

        //-- Devolver el resultado obtenido
        return URL;
      },



      //----------------------------------------------------------
      //--- Obtener Chart (JSON)
      //----------------------------------------------------------
      p98t229m(metodo) {

        //-- Una vez DESCONECTADOS : Ya no realizamos nuevas peticiones al servidor
        if (!this.$store.state.strUsuarioAutenticado) { return; }

        //-- Mostrar los indicadores de actividad
        this.$store.commit('p10StrRecibiendoDatos', true);

        //-- Determinar si hay (al menos) 1 Distribuidor Seleccionado
        if (this.$store.state.strListaDistribuidoresSeleccionados.length < 1) { return; }
        //console.log('=== Distribuidores Seleccionados ===');
        //console.dir(this.$store.state.strListaDistribuidoresSeleccionados);

        //-- Inicilizar TODAS las Charts
        var i1 = 0;
        var n1    = {};        
        n1.data   = global.lnkMinimalChartObject;

        while (i1 < global.lnkMaxCharts) {
          n1.indice = i1;

          switch (metodo) {
            case '11106' :
              this.$store.commit('p10StrT229M11106', n1);
              break;
            case '11206' :
              this.$store.commit('p10StrT229M11206', n1);
              break;
            case '11306' :
              this.$store.commit('p10StrT229M11306', n1);
              break;
            case '11406' :
              this.$store.commit('p10StrT229M11406', n1);
              break;
            case '11506' :
              this.$store.commit('p10StrT229M11506', n1);
              break;
            case '11606' :
              this.$store.commit('p10StrT229M11606', n1);
              break;

            case '11616' :
              this.$store.commit('p10StrT229M11616', n1);
              break;
            }
  
          i1 += 1;
        }

        //-- Recorrer la Lista de Distribuidores Seleccionados
        i1 = 0;
        while (i1 < this.$store.state.strListaDistribuidoresSeleccionados.length) {
          //console.log('Indice = '+i1+ ' --> '+this.$store.state.strListaDistribuidoresSeleccionados[i1]);

          var r1 = this.$store.state.strListaDistribuidores.find(registro => {
            return (registro.cod == this.$store.state.strListaDistribuidoresSeleccionados[i1]);
          });
  
          //-- Solicitud de Datos al Servidor 
          var URL = global.lnkServerAppURL + "s="+this.$store.state.strIDSesion+"&u="+this.$store.state.strUsuario+"&c=&d="+r1.cod+"&n="+encodeURIComponent(this.f75OfuscarTexto(r1.nif))+"&t=229&m=999&x="+metodo+"^"+this.$store.state.strScreenWidth+"^"+i1+"^"+this.$store.state.strDesdeFechaConsulta+"^"+this.$store.state.strHastaFechaConsulta;
          //console.log(URL);
  
          axios.get(URL, {responseEncoding: 'utf-8'})
          .then(respuesta => {
          
              var datos = respuesta.data;
              //console.log('---- Datos ---');
              //console.dir(datos);
              //console.log('');
  
              var flg = global.lnkGetDataError;
              if (datos.flg) {  flg = datos.flg; }
  
              //-- Actualizar Resultados
              if (flg == global.lnkGetDataOk) {
                //console.dir(datos.t229m106);
                //console.log('');
  
                //console.dir(this.f99JSONFuncional(datos.t229m106));
                //console.log('');
                var n2 = {};
                n2.indice = datos.num; 

                switch (metodo) {
                  case '11106':
                    n2.data   = this.f99JSONFuncional(JSON.stringify(datos.t229m106));
                    this.$store.commit('p10StrT229M11106', n2);
                    break;
                  case '11206':
                    n2.data   = this.f99JSONFuncional(JSON.stringify(datos.t229m206));
                    this.$store.commit('p10StrT229M11206', n2);
                    break;
                  case '11306':
                    n2.data   = this.f99JSONFuncional(JSON.stringify(datos.t229m306));
                    this.$store.commit('p10StrT229M11306', n2);
                    break;
                  case '11406':
                    n2.data   = this.f99JSONFuncional(JSON.stringify(datos.t229m406));
                    this.$store.commit('p10StrT229M11406', n2);
                    break;
                  case '11506':
                    n2.data   = this.f99JSONFuncional(JSON.stringify(datos.t229m506));
                    this.$store.commit('p10StrT229M11506', n2);
                    break;
                  case '11606':
                    n2.data   = this.f99JSONFuncional(JSON.stringify(datos.t229m606));
                    this.$store.commit('p10StrT229M11606', n2);
                    break;

                  case '11616':
                    n2.data   = this.f99JSONFuncional(JSON.stringify(datos.t229m616));
                    this.$store.commit('p10StrT229M11616', n2);
                    break;
                }

              } else {

                if (datos.msg) { 
                  this.p99AnuncioIH1('2','7','ERROR', datos.msg,0);
  
                  //-- (E90) Sesion No Encontrada -> Pantalla de Login
                  if (datos.msg.search("(E90)") !== -1) { 
                    this.$store.commit('p10StrAbandonarSesion', true); 
                    this.$store.commit('p10StrUsuarioAutenticado', false); 
                  }
                  
                } else {
                  this.p99AnuncioIH1('2','7','ERROR', '(E22911'+metodo+') Error Desconocido',0);
                }
              }
  
              this.$store.commit('p10StrRecibiendoDatos', false);
  
          })
          .catch(error => {
            this.$store.commit('p10StrRecibiendoDatos', false);
  
            this.p99AnuncioIH1('2','7','ERROR', error.message,0);
          });
  
          //-- Siguiente
          i1 += 1;

        }

      },


      //--------------------------------------------------------------------------------------
      //-- Procesar contenido JSON (transformando Funciones en modo Texto a Funciones Reales)
      //--------------------------------------------------------------------------------------
      f99JSONFuncional(texto) {

        var jsonTransformed = JSON.parse(texto, function (key, value) {

            //-- Crear FUNCION real, a partir del valor "texto"
            if (value && (typeof value === 'string') && value.indexOf("function") === 0) {
              var jsFunc = new Function('return ' + value)();
              return jsFunc;
            }
      
            //-- Resto de casos
            return value;
        });
          
        return jsonTransformed;

      },

      //--------------------------------------------------------------------------------------
      //-- Eliminar cualquier caracter especial de control
      //--------------------------------------------------------------------------------------
      f99TextoLimpio(texto) {
        //--------------------------------------------------------------------------------------
        // \r    = CR
        // \n    = LF
        // x0B   = VT
        // x0C   = FF
        // x5E   = ^
        // u0085 = LF
        // u2028 = Line      Separator
        // u2029 = Paragraph Separator
        //--------------------------------------------------------------------------------------

        // eslint-disable-next-line no-control-regex
        var textoLimpio = texto.replace(/[\r\n\x0B\x0C\x5E\u0085\u2028\u2029]+/g," ");
        return textoLimpio;
      },

      
      //----------------------------------------------------------
      //--- Mostrar mensaje en ventana reducida
      //--- y esperar hasta que se pulse (Ok)
      //----------------------------------------------------------
      /*
      p99MensajeError(mensaje) {
        
        //-- Eliminar cualquier caracter especial de control
        var mensajeLimpio = mensaje.replace(/[\r\n\x0B\x0C\u0085\u2028\u2029]+/g," ");

        //-- Dejar evidencia del error
        console.error("### ERROR ### ("+ mensajeLimpio +")");

        //-- Mostrar la alerta al usuario
        alert({
            title: global.lnkAppName,
            message: mensaje,
            okButtonText: "OK"
          }).then(() => {
            console.info("***(e01)*** Mensaje de ERROR Leído por el Usuario : ("+ mensajeLimpio +")");
          });

      },
      */
 

      //----------------------------------------------------------
      //--- Mensajes Dinámicos
      //----------------------------------------------------------
      // eslint-disable-next-line no-unused-vars
      p99AnuncioIH1(tipoAnuncio, ubicacion, titulo, subtitulo, segundos) {
        //---------------------------------------------------------------------------------------------------------------------------------------------------------
        //==== Tipos de Anuncios ====       =================================== Ejemplos de Uso ===============================
        //---------------------------------------------------------------------------------------------------------------------------------------------------------
        // (1) - Éxito                      this.p99AnuncioIH1('1','1','¡ Éxito !', 'La tarea se ha realizado con éxito',0);
        // (2) - Error                      this.p99AnuncioIH1('2','1','ERROR', 'La tarea NO ha podido ser finalizada',3);
        // (3) - Aviso                      this.p99AnuncioIH1('3','1','Aviso', 'No se ha indicado la descripción de la tarea',5);
        // (4) - Sugerencia                 this.p99AnuncioIH1('4','1','Sugerencia', 'Indique 2 ó 3 valores',10);
        // (5) - Información                this.p99AnuncioIH1('5','1','Información', 'Si compra 2 cajas más, podrá recibir 1 Botella GRATIS',8);
        //---------------------------------------------------------------------------------------------------------------------------------------------------------

        //---------------------------------------------------------------------------------------------------------------------------------------------------------
        //========== Tipos de Ubicación =============                            =================================== Ejemplos de Uso ===============================
        //---------------------------------------------------------------------------------------------------------------------------------------------------------
        // (1) - Izquierda - Arriba
        // (2) - Izquierda - Centro
        // (3) - Izquierda - Abajo
        //
        // (4) - Centro - Arriba
        // (5) - Centro - Centro
        // (6) - Centro - Abajo
        //
        // (7) - Derecha - Arriba
        // (8) - Derecha - Centro
        // (9) - Derecha - Abajo
        //
        // (Otro Valor) = VxD = (7)-Derecha - Arriba
        //---------------------------------------------------------------------------------------------------------------------------------------------------------
        
        //-- Determinar la Ubicación
        var wrkUbicacion = ubicacion;
        if ((wrkUbicacion < '1') || (wrkUbicacion > '9')) { wrkUbicacion = '7'; }

        //....

        var attUbicacion = null;

        switch (wrkUbicacion) {

          case '1':
            attUbicacion = SnotifyPosition.leftTop;
            break;

          case '2':
            attUbicacion = SnotifyPosition.leftCenter;
            break;

          case '3':
            attUbicacion = SnotifyPosition.leftBottom;
            break;

          case '4':
            attUbicacion = SnotifyPosition.centerTop;
            break;

          case '5':
            attUbicacion = SnotifyPosition.centerCenter;
            break;

          case '6':
            attUbicacion = SnotifyPosition.centerBottom;
            break;

          case '7':
            attUbicacion = SnotifyPosition.rightTop;
            break;

          case '8':
            attUbicacion = SnotifyPosition.rightCenter;
            break;

          case '9':
            attUbicacion = SnotifyPosition.rightBottom;
            break;

          default:
            attUbicacion = SnotifyPosition.rightTop;
            break;                                                                                         
        }

        //-- Determinar el Tipo de Anuncio
        var wrkTipoAnuncio = tipoAnuncio;
        if ((wrkTipoAnuncio < '1') || (wrkTipoAnuncio > '5')) { wrkTipoAnuncio = '1'; }

        //....

        var attTipoAnuncio = null;

        switch (wrkTipoAnuncio) {

          case '1':
            attTipoAnuncio = SnotifyStyle.success;
            break;

          case '2':
            attTipoAnuncio = SnotifyStyle.error;
            break;
  
          case '3':
            attTipoAnuncio = SnotifyStyle.warning;
            break;
    
          case '4':
            attTipoAnuncio = SnotifyStyle.simple;
            break;
      
          case '5':
            attTipoAnuncio = SnotifyStyle.info;
            break;

          default :
            attTipoAnuncio = SnotifyStyle.simple;
            break;
        }

        //----------------------------------------------------------------------
        //-- Revisar la Duración
        //----------------------------------------------------------------------
        //   -1            : Valor Temporal Predeterminado
        //    0             : Permanente (hasta que el usuario hace "click")
        //    1 ... 999999 : Temporal (auto-destruir tras N segundos)
        //----------------------------------------------------------------------
        if (segundos < 0)   { segundos = 20; }
        if (segundos > 60)  { segundos = 60; }

        //---------------------------------
        //-- Mostrar el Anuncio
        //---------------------------------
        /*
        this.$snotify.create({
          title: titulo,
          body: subtitulo,
          config: {
            position: attUbicacion,
            type: attTipoAnuncio,
            timeout: segundos * 1000,
            closeOnClick: true,
          }
        });
        */

        this.$snotify.html(`<div class="snotifyToast__title"><b>` + titulo + `</b></div>
                            <div class="snotifyToast__body">`+subtitulo+`</div> `,
                            {
                              position: attUbicacion,
                              type: attTipoAnuncio,
                              timeout: segundos * 1000,
                              showProgressBar: true,
                              closeOnClick: true,
                              pauseOnHover: true,
                             });

      },

      //----------------------------------------------------------
      //--- Mensajes Dinámicos
      //----------------------------------------------------------
      // eslint-disable-next-line no-unused-vars
      p99MensajeIH1(tipo, titulo, subtitulo, indicio, textoBoton) {

        //---------------------------------------------------------------------------------------------------------------------------------------------------------
        //========== Tipos de Mensajes =============                            =================================== Ejemplos de Uso ===============================
        //---------------------------------------------------------------------------------------------------------------------------------------------------------
        // (1) - Éxito                                                          this.p99MensajeIH1('1','¡ Éxito !', 'La tarea se ha realizado con éxito','',null);
        //
        // (2) - Error                                                          this.p99MensajeIH1('2','ERROR', 'La tarea NO ha podido ser finalizada','',null);
        //
        // (3) - Aviso                                                          this.p99MensajeIH1('3','ATENCIÓN', 'No se ha indicado la descripción de la tarea','',null);
        //
        // (4) - Advertencia                                                    this.p99MensajeIH1('4','ADVERTENCIA', 'Tarea NO permitida','',null);
        //
        // (5) - Informativo                                                    this.p99MensajeIH1('5','Atención', 'Si compra 2 cajas más, podrá recibir 1 Botella GRATIS','',null);
        //
        // (6) - Pregunta (escoger entre varias opciones [botones])             this.p99MensajeIH1('6','Pregunta', '¿ Quieres agregar estos 10 artículos a la Cesta ?','No','Sí');
        //
        // (7) - Petición de Respuesta (texto)                                  this.p99MensajeIH1('7','Pregunta', 'Indique el Nombre para esta CESTA','Nombre de la Cesta','Confirmar');
        //
        // (8) -  ** Uso Futuro **
        //
        // (9) -  ** Uso Futuro **
        //
        //------------------------------------------

        //-- Eliminar cualquier caracter especial de control
        // eslint-disable-next-line no-control-regex
        var mensajeLimpio = subtitulo.replace(/[\r\n\x0B\x0C\u0085\u2028\u2029]+/g," ");

        /*
        console.log(' *** Nuevo Mensaje : '+mensajeLimpio+' ***');        
        this.$swal(titulo, subtitulo, 'warning');
        console.log('-- Mensaje Mostrado --');
        */

        //-- Posible "traducción" (a humano) de los mensajes de error recibidos
        if (mensajeLimpio == "Request failed with status code null") {
          mensajeLimpio = "La conexión a Internet parece estar desactivada"
        }

        //::::::::::::::::::::::::
        //::: (1) - EXITO 
        //::::::::::::::::::::::::
        if (tipo == "1") {
            //-- Mostrar Mensaje
            this.$swal(titulo, mensajeLimpio, 'success').
            then((result) => {
               console.log('Mensaje de ÉXITO ['+titulo+'/'+mensajeLimpio+'] : Leído ('+result+')')
            }).catch((error) => {
               console.error(error)
            });
        }
        
        //::::::::::::::::::::::::
        //::: (2) - ERROR
        //::::::::::::::::::::::::
        if (tipo == "2") {
          //-- Mostrar Mensaje
          this.$swal(titulo, mensajeLimpio, 'error').
          then((result) => {
             console.log('Mensaje de ERROR ['+titulo+'/'+mensajeLimpio+'] : Leído ('+result+')')
          }).catch((error) => {
             console.error(error)
          });
        }

        //::::::::::::::::::::::::
        //::: (3) - AVISO
        //::::::::::::::::::::::::
        if (tipo == "3") {
          //-- Mostrar Mensaje
          this.$swal(titulo, mensajeLimpio, 'info').
          then((result) => {
             console.log('Mensaje de AVISO ['+titulo+'/'+mensajeLimpio+'] : Leído ('+result+')')
          }).catch((error) => {
             console.error(error)
          });
        }

        //::::::::::::::::::::::::
        //::: (4) - ADVERTENCIA
        //::::::::::::::::::::::::
        if (tipo == "4") {
          //-- Mostrar Mensaje
          this.$swal(titulo, mensajeLimpio, 'warning').
          then((result) => {
             console.log('Mensaje de ADVERTENCIA ['+titulo+'/'+mensajeLimpio+'] : Leído ('+result+')')
          }).catch((error) => {
             console.error(error)
          });
        }

        //::::::::::::::::::::::::
        //::: (5) - INFORMACIÓN
        //::::::::::::::::::::::::
        if (tipo == "5") {
          //-- Mostrar Mensaje
          this.$swal(titulo, mensajeLimpio, 'info').
          then((result) => {
             console.log('Mensaje INFORMATIVO ['+titulo+'/'+mensajeLimpio+'] : Leído ('+result+')')
          }).catch((error) => {
             console.error(error)
          });
        }

        //::::::::::::::::::::::::
        //::: (6) - PREGUNTA
        //::::::::::::::::::::::::
        if (tipo == "6") {

          this.$swal({
            title : titulo, 
            text : mensajeLimpio, 
            type : 'question',
            showCancelButton : true,
            cancelButtonText: indicio,
            confirmButtonText : textoBoton,
            showCloseButton: true,
            showLoaderOnConfirm: true 
          }).          
          then((result) => {
            //console.log('Resultado : '+result);
            
            if (result.value) {
              console.log('!!! Éxito !!!');
              return new Promise(resolve => { resolve(textoBoton); });
            } else {
              console.log(' *** Acción NO CONFIRMADA *** ');
              return new Promise(resolve => { resolve(indicio); });
            }            
          });
          
        }

        //::::::::::::::::::::::::::::::::::::
        //::: (7) - PETICIÓN DE RESPUESTA
        //::::::::::::::::::::::::::::::::::::
        if (tipo == "7") {
          //-- Mostrar Mensaje
          /*
          this.$swal({
            title: titulo,
            html:
              ' <input ' + indicio + '</em>' +
              ' Titulo <a href="#">'+ titulo +'</a> ' +
              ' mensaje <b>'+ mensajeLimpio +'</b>' +
              '<strong>Cualquier otro contenido</strong>',
            showCloseButton: false,
            showCancelButton: true,
            focusConfirm: false,
          });
          */

          this.$swal({
            title: titulo,
            text: mensajeLimpio,
            input: 'text',
            inputPlaceholder: indicio,
            showCloseButton: false,
            showCancelButton : true,
            cancelButtonText: "Cancelar"
          }).
          then((result) => {
            //console.log('Resultado :');
            //console.dir(result);
            
            if (result.value) {
              console.log('!!! Éxito !!!');
              return new Promise(resolve => { resolve(result.value); });
            } else {
              console.log(' *** Acción NO CONFIRMADA *** ');
              return new Promise(resolve => { resolve(''); });
            }            
          });

        }

        //-- Llamada a función (then))
        return new Promise(resolve => {
          resolve('???');
        });
        

      },

      //----------------------------------------------------------------
      //--- Obtener Ruta Absoluta de la Imagen a mostrar (formato PNG)
      //----------------------------------------------------------------
      f99ImageName(imagen) {
        return global.lnkServerImgURL + imagen + ".png";
      }, 

      
      //----------------------------------------------------------------
      //--- Obtener Ruta Absoluta de la Imagen a mostrar (formato GIF)
      //----------------------------------------------------------------
      f99ImageNameGIF(imagen) {
        return global.lnkServerImgURL + imagen + ".gif";
      }, 

      
      //----------------------------------------------------------
      //--- Obtener Nombre Imagen (segun Tipo de Documento)
      //----------------------------------------------------------
      f99IconoDocumento(tipoDocumento, color) {
        //console.log('f99IconoDocumento ['+tipoDocumento+']');
        return "ih1-documento-" + tipoDocumento + "-" + color;
      }
      


/*
//==========================================================================================================================
//----------   Código VERIFICADO, pendiente de aplicar (cuando resulte necesario)
//==========================================================================================================================

    //------------------------------------------------------------------------------------------
    //--  Mensajes (en modo Post-it)
    //------------------------------------------------------------------------------------------
    lp90PruebaAnuncios01() {
        console.log('*** lp90PruebaAnuncios01 ***');
        //this.$snotify.success('Example body content');
        
        this.$snotify.success('La tarea ha finalizado con ÉXITO', 'Enhorabuena', {timeout: 0});
        this.$snotify.error('No hay contacto con el servidor. ¿ Tienes acceso a Internet ?', 'Error');
        this.$snotify.warning('Sólo quedan 10 unidades', 'Aviso', {timeout: 0});
        this.$snotify.info('Último acceso realizado hace 43 días', 'Información', {timeout: 0});
        this.$snotify.simple('Indica tu dirección de correo', 'Sugerencia', {timeout: 0});
    },

    //------------------------------------------------------------------------------------------
    //--  Mensajes (en modo Post-it)
    //------------------------------------------------------------------------------------------
    lp90PruebaAnuncios02() {

        this.$snotify.prompt('¿ Cuántos dedos tienes en la mano ?', 'Pregunta', {
          timeout: 0,
          placeholder: 'Respuesta'
        });

        // eslint-disable-next-line no-unused-vars
        this.$snotify.async('Descargando contenidos ....', 'Sincronizando', () => new Promise((resolve, reject) => {
            setTimeout(() => resolve({
            title: '¡ Éxito !',
            body: 'Los datos necesarios han sido actualizados correctamente',
            config: {
                closeOnClick: true
            }
            }), 6000);
        }));

        this.$snotify.confirm('¿ Estás seguro ?', 'Atención', {
            timeout: 5000,
            showProgressBar: true,
            closeOnClick: false,
            pauseOnHover: true,
            buttons: [
            //Yes
            {text: 'Sí', action: () => console.log('Respuesta : SÍ'), bold: false},
            //No
            {text: 'No', action: () => console.log('Respuesta : NO')},
            //Later
            {text: 'Más tarde', action: (toast) => {console.log('Respuesta : MÁS TARDE'); this.$snotify.remove(toast.id); } },
            //Close
            {text: 'Cerrar', action: (toast) => {console.log('Respuesta : CERRAR'); this.$snotify.remove(toast.id); }, bold: true},
            ]
        });

      },

      //------------------------------------------------------------------------------------------
      //--  Mensajes (en modo Post-it)
      //------------------------------------------------------------------------------------------
      lp90PruebaAnuncios03() {

          this.$snotify.html(`<div class="snotifyToast__title"><b>Título Mensaje HTML</b></div>
                              <div class="snotifyToast__body"><i>Mensaje</i> <b>HTML</b> <u>contenido dinámico</u></div> `, {
              timeout: 5000,
              showProgressBar: true,
              closeOnClick: false,
              pauseOnHover: true,
          });

          //---------

          const yesAction = (toast) => {
            if (!toast.value.match('1234')) {
              console.log('Respuesta incorrecta');
              toast.valid = false;
              return false;
            } else {
              console.log('Respuesta CORRECTA');
              toast.valid = true; // default value
              this.$snotify.remove(toast.id)
            }
          }

          const noAction = (toast) => {
            console.log('Respuesta : NO');
            this.$snotify.remove(toast.id) // default
          }

          this.$snotify.prompt('¿ Tienes más de 18 años ?', 'Pregunta', {
            buttons: [
              {text: 'Sí', action: yesAction, bold: true },
              {text: 'No', action: noAction },
            ],
            placeholder: 'Dinos tu respuesta'
          });

          //---------------------------

          this.$snotify.simple('Mensaje con Icono Asociado', 'Ejemplo', {
            timeout: 8000,
            showProgressBar: false,
            closeOnClick: true,
            icon: global.lnkServerImgURL + 'ih1-stock-azul.png'
          });
      },

    //------------------------------------------------------------------------------------------
    //--  Mensajes (en modo Ventana)
    //------------------------------------------------------------------------------------------
    lp90PruebaMensajes(tipo) {
        console.log('*** lp90PruebaMensajes ***');

        if (tipo == '1') {
            this.p99MensajeIH1('1','¡ Éxito !', 'La tarea se ha realizado con éxito','',null);
        }

        if (tipo == '2') {
            this.p99MensajeIH1('2','ERROR', 'La tarea NO ha podido ser finalizada','',null);
        }

        if (tipo == '3') {
            this.p99MensajeIH1('3','ATENCIÓN', 'No se ha indicado la descripción de la tarea','',null);
        }

        if (tipo == '4') {
            this.p99MensajeIH1('4','ADVERTENCIA', 'Tarea NO permitida','',null);
        }
        
        if (tipo == '5') {
            this.p99MensajeIH1('5','Atención', 'Si compra 2 cajas más, podrá recibir 1 Botella GRATIS','',null);
        }
         
        if (tipo == '6') {
            this.p99MensajeIH1('6','Pregunta', '¿ Quieres agregar estos 10 artículos a la Cesta ?','No','Sí');
        }

        if (tipo == '7') {
            this.p99MensajeIH1('7','Pregunta', 'Indique el Nombre para esta CESTA','Nombre de la Cesta','Confirmar');
        }

    },


      //------------------------------------------------------------------------------------------
      //--  Mensajes (en modo Post-it)
      //------------------------------------------------------------------------------------------
      lp90PruebaAnuncios04() {
        this.p99AnuncioIH1('1','1','Éxito','La tarea ha finalizado correctamente.',10)
        this.p99AnuncioIH1('2','3','Error','Error <b>E27</b><br/>No se ha indicado el <i>USUARIO</i>',30)
        this.p99AnuncioIH1('3','5','Aviso','La tarea ha finalizado correctamente.',20)
        this.p99AnuncioIH1('4','9','Advertencia','La tarea ha finalizado correctamente.',15)
        this.p99AnuncioIH1('5','7','Información','La tarea ha finalizado correctamente.',40)
      }


*/
      
    }
  }
  